import { Component, Input, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-star-rating',
  imports: [],
  templateUrl: './star-rating.component.html',
  standalone: true,
  styleUrl: './star-rating.component.scss'
})
export class StarRatingComponent {
  @Input({ required: true }) rating!: number;
  @Input({ required: true }) max!: number;

  fullArray: any[] = [];
  emptyArray: any[] = [];
  halfStar = false;

  ngOnChanges(changes: SimpleChanges) {
    this.recalculate();
  }

  private recalculate(): void {
    // Fallbacks/Koersionen, um NaN/negativ zu vermeiden
    const max = Number.isFinite(this.max) && this.max > 0 ? Math.floor(this.max) : 5;
    const ratingRaw = Number.isFinite(this.rating) ? this.rating : 0;

    // clamp: [0, max]
    const clamped = Math.min(Math.max(ratingRaw, 0), max);

    const rounded = this.roundHalf(clamped);
    const full = Math.floor(rounded);
    const hasHalf = rounded - full >= 0.5;

    // Restliche leere Sterne (niemals negativ)
    const empty = Math.max(0, max - full - (hasHalf ? 1 : 0));

    this.halfStar = hasHalf;
    this.fullArray = this.makeArray(full);
    this.emptyArray = this.makeArray(empty);
  }

  private makeArray(n: number): any[] {
    // schützt gegen negative/NaN Längen
    const len = Math.max(0, Math.floor(Number.isFinite(n) ? n : 0));
    return Array.from({ length: len });
  }

  private roundHalf(num: number): number {
    const decimal = num % 1;
    if (decimal < 0.25) {
      return Math.floor(num);
    } else if (decimal < 0.75) {
      return Math.floor(num) + 0.5;
    } else {
      return Math.ceil(num);
    }
  }

  trackByIndex = (index: number) => index;
}
